import React, {Component} from 'react';
import {Container, Row, Col, Button} from 'react-bootstrap';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import AuthService from '../../../../../services/auth-service/AuthService';
import DateUtil from '../../../../../utils/DateUtil';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import dialog from '../../../../../components/dialog/Dialog';
import confirmDialog from '../../../../../components/dialog/ConfirmDialog';
import RemotingService from "../../../../../services/remoting-service/RemotingService";
import NoteEditModal from "../../notes/NoteEditModal";

export default class NoteListModalV2 extends Component {
    constructor(props) {
        super(props);

        this.state = {
            notes: []
        };
    }

    componentDidMount() {
        this.retrieveNotes(this.props.referralId)
    }

    retrieveNotes(referralId) {
        RemotingService.getRemoteCall(`api/insurance/coordinator/v2/referral/${referralId}/notes`,
            null,
            (result) => {
                this.setState({notes: result});
            })
    }

    createNote(referralId, note) {
        RemotingService.postRemoteCall(`api/insurance/coordinator/v2/referral/${referralId}/notes`,
            note,
            () => {
                this.retrieveNotes(referralId); // fetch notes again
            }, null, true, null)
    }

    updateNote(referralId, noteKey, note) {
        RemotingService.putRemoteCall(`api/insurance/coordinator/v2/referral/notes/${noteKey}`,
            note,
            () => {
                this.retrieveNotes(referralId); // fetch notes again
            }, null, true, null)
    }

    deleteNote(referralId, note) {
        confirmDialog(
            "Delete Note",
            `Are you sure you want to delete the note "${note.header}"?`,
            () => {
                RemotingService.deleteRemoteCall(`api/insurance/coordinator/v2/referral/notes/${note.noteKey}`,
                    null,
                    () => {
                        this.retrieveNotes(referralId); // fetch notes again
                    }, null, true, null)
            });
    }


    openNoteEdit = (note = null) => {
        let closeEditDialog;
        closeEditDialog = dialog({
            title: "View/Edit Note",
            component: (
                <NoteEditModal
                    note={note}
                    newMode={false}
                    readOnly={this.props.readOnly}
                    onSave={(savedNote) => {
                        this.updateNote(this.props.referralId, note.noteKey, savedNote);
                        closeEditDialog(); // Close the edit modal
                    }}
                />
            ),
            size: "md"
        });
    };

    openNoteCreate = () => {
        if (this.props.readOnly) {
            return;
        }
        let closeEditDialog;
        closeEditDialog = dialog({
            title: "Add New Note",
            component: (
                <NoteEditModal
                    note={null}
                    newMode={true}
                    onSave={(savedNote) => {
                        this.createNote(this.props.referralId, savedNote);
                        closeEditDialog(); // Close the edit modal
                    }}
                />
            ),
            size: "md"
        });
    }

    openHistoryDialog = (note, history) => {
        dialog({
            title: `History for "${note.header || 'No Header'}"`,
            component: (
                <div style={{minWidth: '600px', minHeight: '400px'}}>
                    <DataTable
                        value={history}
                        emptyMessage="No history found for this note"
                        className="p-datatable-sm"
                        scrollable
                        scrollHeight="350px"
                    >
                        <Column 
                            header="Note Header" 
                            body={this.headerTemplate}
                            style={{width: '40%'}}
                        />
                        <Column 
                            header="Staff Name" 
                            body={this.staffNameTemplate}
                            style={{width: '30%'}}
                        />
                        <Column 
                            header="Last Edited" 
                            body={this.dateTemplate}
                            style={{width: '30%'}}
                        />
                    </DataTable>
                </div>
            ),
            size: "lg"
        });
    }

    openDeletedNotesDialog = () => {
        const deletedNotes = this.getDeletedNotes();
        dialog({
            title: "Deleted Notes",
            component: (
                <div style={{minWidth: '600px', minHeight: '400px'}}>
                    <DataTable
                        value={deletedNotes}
                        emptyMessage="No deleted notes found"
                        className="p-datatable-sm"
                        scrollable
                        scrollHeight="350px"
                    >
                        <Column 
                            header="Note Header" 
                            body={this.headerTemplate}
                            style={{width: '35%'}}
                        />
                        <Column 
                            header="Staff Name" 
                            body={this.staffNameTemplate}
                            style={{width: '25%'}}
                        />
                        <Column 
                            header="Last Edited" 
                            body={this.dateTemplate}
                            style={{width: '25%'}}
                        />
                        <Column 
                            header="Actions" 
                            body={this.deletedNotesActionsTemplate}
                            style={{width: '15%', textAlign: 'center'}}
                        />
                    </DataTable>
                </div>
            ),
            size: "lg"
        });
    }

    sortNotesByDate = (notes) => {
        return [...notes].sort((a, b) => {
            const dateA = new Date(a.updateDate);
            const dateB = new Date(b.updateDate);
            return dateB - dateA; // Descending order (newest first)
        });
    };

    getActiveNotes = () => {
        const allNotes = this.state.notes || [];
        return this.sortNotesByDate(allNotes.filter(note => note.isActive !== false));
    };

    getNoteHistory = (noteKey) => {
        const allNotes = this.state.notes || [];
        return this.sortNotesByDate(allNotes.filter(note => note.noteKey === noteKey && note.isActive === false));
    };

    getNoteHistoryForDeletedNotes = (noteKey) => {
        const allNotes = this.state.notes || [];
        const deletedNotes = this.sortNotesByDate(allNotes.filter(note => note.noteKey === noteKey && note.isActive === false));
        if (deletedNotes && deletedNotes.length > 0) {
            return deletedNotes.slice(1)
        }
    }

    getDeletedNotes = () => {
        const allNotes = this.state.notes || [];
        const noteKeyGroups = {};
        
        // Group notes by noteKey
        allNotes.forEach(note => {
            if (!noteKeyGroups[note.noteKey]) {
                noteKeyGroups[note.noteKey] = [];
            }
            noteKeyGroups[note.noteKey].push(note);
        });
        
        // Find noteKeys where ALL records are isActive=false
        const deletedNoteKeys = Object.keys(noteKeyGroups).filter(noteKey => 
            noteKeyGroups[noteKey].every(note => note.isActive === false)
        );
        
        // Return the most recent record for each deleted noteKey
        return deletedNoteKeys.map(noteKey => {
            const notesForKey = noteKeyGroups[noteKey];
            return this.sortNotesByDate(notesForKey)[0]; // Get most recent
        });
    };

    headerTemplate = (note) => {
        return <div
            className="notes-modal-header"
            onClick={() => this.openNoteEdit(note)}
            style={{ cursor: 'pointer' }}
        >
            {note.header || 'No Header'}
        </div>
    };
    
    staffNameTemplate = (note) => {
        return note.staff.name;
    };
    
    dateTemplate = (note) => {
        return DateUtil.formatDate(note.updateDate, 'DD/MM/YYYY HH:mm');
    };

    isUserNote = (note) => {
        const currentStaffId = AuthService.getStaffId();
        return note.staff.id === currentStaffId;
    };

    actionsTemplate = (note) => {
        const canDelete = !this.props.readOnly && this.isUserNote(note);
        const noteHistory = this.getNoteHistory(note.noteKey);
        
        return (
            <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
                <Button
                    variant="link"
                    size="sm"
                    className={noteHistory.length === 0 ? "text-muted" : "text-info"}
                    style={{
                        padding: "2px 6px",
                        opacity: noteHistory.length === 0 ? 0.3 : 1,
                        cursor: noteHistory.length === 0 ? "not-allowed" : "pointer"
                    }}
                    onClick={() => this.openHistoryDialog(note, noteHistory)}
                    title={noteHistory.length === 0 ? "No history available for this note" : "View history for this note"}
                    disabled={noteHistory.length === 0}
                >
                    <FontAwesomeIcon icon="history" size="sm" />
                </Button>
                <Button
                    variant="link"
                    size="sm"
                    className={canDelete ? "text-danger" : "text-muted"}
                    style={{
                        opacity: canDelete ? 1 : 0.3,
                        cursor: canDelete ? "pointer" : "not-allowed",
                        padding: "2px 6px"
                    }}
                    onClick={canDelete ? () => this.deleteNote(this.props.referralId, note) : undefined}
                    disabled={!canDelete}
                    title={canDelete ? "Delete note" : "You can only delete notes you created"}
                >
                    <FontAwesomeIcon icon="trash" size="sm" />
                </Button>
            </div>
        );
    };

    deletedNotesActionsTemplate = (note) => {
        const noteHistory = this.getNoteHistoryForDeletedNotes(note.noteKey);
        
        return (
            <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
                <Button
                    variant="link"
                    size="sm"
                    className={noteHistory.length === 0 ? "text-muted" : "text-info"}
                    style={{
                        padding: "2px 6px",
                        opacity: noteHistory.length === 0 ? 0.3 : 1,
                        cursor: noteHistory.length === 0 ? "not-allowed" : "pointer"
                    }}
                    onClick={() => this.openHistoryDialog(note, noteHistory)}
                    title={noteHistory.length === 0 ? "No history available for this deleted note" : "View history for this deleted note"}
                    disabled={noteHistory.length === 0}
                >
                    <FontAwesomeIcon icon="history" size="sm" />
                </Button>
            </div>
        );
    };
    
    renderDataTable = (notes, isHistoryTab = false) => {
        return (
            <DataTable
                value={notes}
                emptyMessage="No notes found"
                className="p-datatable-sm"
                scrollable
                scrollHeight="300px"
            >
                <Column 
                    header="Note Header" 
                    body={this.headerTemplate}
                    style={{width: '35%'}}
                />
                <Column 
                    header="Staff Name" 
                    body={this.staffNameTemplate}
                    style={{width: '25%'}}
                />
                <Column 
                    header="Last Edited" 
                    body={this.dateTemplate}
                    style={{width: '25%'}}
                />
                <Column 
                    header="Actions" 
                    body={this.actionsTemplate}
                    style={{width: '15%', textAlign: 'center'}}
                />
            </DataTable>
        );
    };

    render() {
        const activeNotes = this.getActiveNotes();
        const deletedNotes = this.getDeletedNotes();
        
        return (
            <>
                <div style={{minWidth: '600px', minHeight: '400px'}}>
                    <Container>
                        <Row className="mb-3">
                            <Col xs={12} className="text-right">
                <Button 
                                    variant="outline-secondary" 
                                    size="sm"
                                    className="mr-2"
                                    onClick={() => this.openDeletedNotesDialog()}
                                    disabled={deletedNotes.length === 0}
                                >
                                    <FontAwesomeIcon icon="trash-alt" className="mr-1" />
                                    Deleted Notes ({deletedNotes.length})
                                </Button>
                <Button 
                                    variant="primary" 
                                    size="sm"
                    onClick={() => this.openNoteCreate()}
                    disabled={this.props.readOnly}
                    style={{ opacity: this.props.readOnly ? 0.6 : 1, cursor: this.props.readOnly ? 'not-allowed' : 'pointer' }}
                                >
                                    <FontAwesomeIcon icon="plus" className="mr-1" />
                                    Add New Note
                                </Button>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                {this.renderDataTable(activeNotes)}
                            </Col>
                        </Row>
                    </Container>
                </div>
            </>
        );
    }
}